/**
 * Created by falknisius on 11.05.17.
 */
import axios from 'axios'
import getString from '../config/strings'
import themeStoreActions from '../stores/ThemeStoreActions'
import uuidV1 from 'uuid/v1'

const PARAMS = {
  baseurl: 'https://ems3.equeo.de/ems-webapp/',
  user: 'mobile_equizzer',
  password: '!Ye9((UUBpjeu6'
}

class APIService {
  static getThemeAndGroupName (code, deviceUuid) {
    const baseurl = PARAMS.baseurl
    const user = PARAMS.user
    const password = PARAMS.password

    if (user === null || password === null || baseurl === null) {
      return Promise.reject(new Error(getString('ERROR_INSUFFICIENT_PARAMS')))
    }

    const url = (baseurl.slice(-1) === '/' ? baseurl : (baseurl + '/')) + 'rest/api/v1/equeoqdFeedback/getTheme'

    let data = new FormData()
    data.append('code', code)
    data.append('deviceuuid', deviceUuid)

    const userPwd = user + ':' + password
    const config = {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: 'Basic ' + btoa(userPwd)
      },
      timeout: 15000
    }
    return new Promise(function (resolve, reject) {
      axios.post(url, data, config).then(function (result) {

        console.log(result)

        if (result.status === 200) {
          if (result.data.success) {
            resolve(result)
          }
          else {
            reject(new Error(getString('ERROR_WRONG_REQUEST')))
          }
        }
        else {
          reject(new Error(getString('ERROR_HTTP_COMMUNICATION')))
        }
      }).catch(function (reason) {
        reject(reason)
      })
    })
  }

  static getTournamentData (id, code, deviceUuid) {
    const baseurl = PARAMS.baseurl
    const user = PARAMS.user
    const password = PARAMS.password

    const url = (baseurl.slice(-1) === '/' ? baseurl : (baseurl + '/')) + 'rest/api/v1/equeoQDTournament/show/' + id

    let data = new FormData()
    data.append('code', code)
    data.append('deviceuuid', deviceUuid)

    const userPwd = user + ':' + password
    const config = {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: 'Basic ' + btoa(userPwd)
      },
      timeout: 15000
    }

    return new Promise((resolve, reject) => {
      axios.post(url, data, config).then((result) => {

        console.log(result)

        if (result.status === 200) {

          console.log(result)

          if (result.data.success) {
            resolve(result.data)
          }
          else {
            reject(new Error(getString('ERROR_WRONG_REQUEST')))
          }
        }
        else {
          reject(new Error(getString('ERROR_HTTP_COMMUNICATION')))
        }
      }).catch(function (reason) {
        reject(reason)
      })
    })
  }

  static getTournamentList (code, deviceUuid) {
    const baseurl = PARAMS.baseurl
    const user = PARAMS.user
    const password = PARAMS.password

    const url = (baseurl.slice(-1) === '/' ? baseurl : (baseurl + '/')) + 'rest/api/v1/equeoQDTournament/list'

    let data = new FormData()
    data.append('code', code)
    data.append('deviceuuid', deviceUuid)

    const userPwd = user + ':' + password
    const config = {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: 'Basic ' + btoa(userPwd)
      },
      timeout: 15000
    }

    return new Promise((resolve, reject) => {
      axios.post(url, data, config).then((result) => {

        console.log(result)

        if (result.status === 200) {

          console.log(result)

          if (result.data.success) {
            resolve(result.data)
          }
          else {
            reject(new Error(getString('ERROR_WRONG_REQUEST')))
          }
        }
        else {
          reject(new Error(getString('ERROR_HTTP_COMMUNICATION')))
        }
      }).catch(function (reason) {
        reject(reason)
      })
    })
  }

  static registerForAblyMessages = (code, tournamentId, deviceUuid) => {
    const baseurl = PARAMS.baseurl
    const user = PARAMS.user
    const password = PARAMS.password

    const url = (baseurl.slice(-1) === '/' ? baseurl : (baseurl + '/')) + 'rest/api/v1/equeoQDTournament/subscribeGameChanges'

    let data = new FormData()
    data.append('tournamentId', tournamentId.toString())
    data.append('code', code)
    data.append('deviceuuid', deviceUuid)

    const userPwd = user + ':' + password
    const config = {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: 'Basic ' + btoa(userPwd)
      },
      timeout: 15000
    }

    return new Promise((resolve, reject) => {
      axios.post(url, data, config).then((result) => {
        if (result.status === 200) {
          if (result.data.success) {
            resolve(result.data)
          }
          else {
            reject(new Error(getString('ERROR_WRONG_REQUEST')))
          }
        }
        else {
          reject(new Error(getString('ERROR_HTTP_COMMUNICATION')))
        }
      }).catch(function (reason) {
        reject(reason)
      })
    })
  }

  static getUserImage (tournamentId, userId, code, deviceUuid) {
    const baseurl = PARAMS.baseurl
    const user = PARAMS.user
    const password = PARAMS.password

    let url = (baseurl.slice(-1) === '/' ? baseurl : (baseurl + '/')) + 'rest/api/v1/equeoQDTournament/getUserPicture'

    const userPwd = user + ':' + password
    const config = {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: 'Basic ' + btoa(userPwd)
      },
      timeout: 15000
    }

    let data = new FormData()
    data.append('tournamentId', tournamentId.toString())
    data.append('code', code)
    data.append('deviceuuid', deviceUuid)
    data.append('userId', userId)

    return new Promise((resolve, reject) => {
      axios.post(url, data, config).then((result) => {
        if (result.status === 200) {
          if (result.data.success) {
            resolve(result.data)
          }
          else {
            reject(new Error(getString('ERROR_WRONG_REQUEST')))
          }
        }
        else {
          reject(new Error(getString('ERROR_HTTP_COMMUNICATION')))
        }
      }).catch(function (reason) {
        reject(reason)
      })
    })
  }

  static getRunningGames (code, tournamentId, gameId, deviceUuid) {
    const baseurl = PARAMS.baseurl
    const user = PARAMS.user
    const password = PARAMS.password

    console.log('gameId', code, tournamentId, gameId, deviceUuid)

    let url = (baseurl.slice(-1) === '/' ? baseurl : (baseurl + '/')) + 'rest/api/v1/equeoQDTournament/game'
    if (gameId){
      url = (baseurl.slice(-1) === '/' ? baseurl : (baseurl + '/')) + 'rest/api/v1/equeoQDTournament/game' + `/${gameId}`
    }
    console.log('url', url)

    let data = new FormData()
    data.append('tournamentId', tournamentId.toString())
    data.append('code', code)
    data.append('deviceuuid', deviceUuid)

    const userPwd = user + ':' + password
    const config = {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: 'Basic ' + btoa(userPwd)
      },
      timeout: 15000
    }

    return new Promise((resolve, reject) => {
      axios.post(url, data, config).then((result) => {
        if (result.status === 200) {
          if (result.data.success) {
            resolve(result.data)
          }
          else {
            reject(new Error(getString('ERROR_WRONG_REQUEST')))
          }
        }
        else {
          reject(new Error(getString('ERROR_HTTP_COMMUNICATION')))
        }
      }).catch(function (reason) {
        reject(reason)
      })
    })
  }

  static async checkActivationCode (code, deviceUuid) {
    try {
      const baseurl = PARAMS.baseurl
      const user = PARAMS.user
      const password = PARAMS.password
      const userPwd = user + ':' + password

      themeStoreActions.setDeviceUuid(deviceUuid)

      const config = {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: 'Basic ' + btoa(userPwd)
        },
        timeout: 15000
      }

      let data = new FormData()
      data.append('code', code)
      data.append('deviceuuid', deviceUuid)

      const url = (baseurl.slice(-1) === '/' ? baseurl : (baseurl + '/')) + 'mobile/api/features/v2/checkRequestCode'

      return new Promise((resolve, reject) => {
        axios.post(url, data, config).then((result) => {

          console.log('activationCode Result', result)

          if (result.status === 200) {
            if (result.data.success) {
              resolve(result.data)
            }
            else {
              reject(new Error(getString('ERROR_WRONG_REQUEST')))
            }
          }
          else {
            reject(new Error(getString('ERROR_HTTP_COMMUNICATION')))
          }
        }).catch(function (reason) {
          reject(reason)
        })
      })
    }
    catch (error) {
      return Promise.reject(error)
    }
  }

}

export default APIService



// WEBPACK FOOTER //
// ./src/services/APIService.js